<template>
  <div class="brokers-holding-list">
    <div class="time-section">
      <span>{{ $t('更新') }}：{{ $dayjs(brokerData.date).format('YYYY-MM-DD 00:00') }}({{ $t('每T+1结算') }})</span>
      <i class="iconfont icon-tishishuoming" @click="showMsg('broker')"></i>
    </div>
    <div class="broker-list">
      <div v-for="(item, index) in sliceBrokerList" :key="index" class="broker-item">
        <div class="broker-name" @click="goPage(item)">
          <span class="one-line">{{ item.brokerName }}</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <div class="broker-proportion">
          <span class="proportion-bar" :style="{ width: (item.ratio / maxRatio) * 100 + '%' }"></span>
          <span class="proportion-value">{{ $digitjs(item.ratio).unit('%').rounded() }}</span>
        </div>
      </div>
      <ShowMoreButton v-if="brokerList.length > initLength" v-model="isMore" />
    </div>
  </div>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import BrokerTip from './BrokerTip'
import { showMsg } from '@/plugins/msg'
export default {
  components: {
    ShowMoreButton,
    BrokerTip
  },
  props: {
    total: Number,
    initLength: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      isMore: false,
      tipVisible: false,
      brokerData: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    brokerList() {
      return this.brokerData.items ?? []
    },
    maxRatio() {
      return this.brokerList[0]?.ratio
    },
    sliceBrokerList() {
      return this.isMore ? this.brokerList : this.brokerList.slice(0, this.initLength)
    }
  },
  created() {
    this.getBrokers()
  },
  methods: {
    showMsg,
    async getBrokers() {
      const res = await this.$post(this.$api.sdk.hk + '/broker/shareholding/ratio', {
        sortField: 'ratio',
        sortType: 1,
        symbol: this.symbol
      })
      const data = res.body?.[0] ?? {}
      data.items = data.items.slice(0, this.total)
      this.brokerData = data
    },
    goPage(item) {
      this.$router.push({
        path: '/bidask/broker',
        query: {
          symbol: this.symbol,
          id: item.brokerId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.brokers-holding-list {
  padding: 0 var(--edge-padding);
  .time-section {
    display: flex;
    justify-content: space-between;
    color: var(--font-color-3);
    padding: 15px 0;
    .iconfont {
      font-size: 13px;
    }
  }
  .broker-item {
    margin-bottom: 10px;
  }
  .broker-name {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .iconfont {
      font-size: 13px;
      margin-left: 5px;
    }
  }
  .broker-proportion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .proportion-bar {
      height: 14px;
      background: var(--main-color-1);
    }
    .proportion-value {
      width: 65px;
      text-align: right;
    }
  }
}
</style>
